// import ReactLink from 'next/link'
import client from "@gql/client";
import React, { useCallback, useState } from "react";
import { Link as ReactLink } from "react-router-dom";
import qPage from '@assets/gql/page.gql';
import { debounce } from "underscore";
export function Link({ href, className, title, children, target, rel, download, onClick }) {
    const [fetched, setFetched] = useState(false);
    const doPrefetch = useCallback(debounce(() => {
        client.query({
            query: qPage,
            variables: {
                uri: href
            }
        });
        setFetched(true);
    }, 300), []);
    return React.createElement(ReactLink, { onMouseEnter: () => { if (!validHref(href, fetched))
            return; doPrefetch(); }, onClick: onClick, to: href || '#', title: title, className: className, target: target, rel: rel, download: download }, children);
}
function validHref(href, fetched) {
    if (fetched)
        return false;
    if (!href)
        return false;
    if (href.indexOf('/') !== 0)
        return false;
    if (href.indexOf('tel:') === 0)
        return false;
    if (href.indexOf('mailto:') === 0)
        return false;
    return true;
}
